export const fmtMoney = (n) => {
  const v = Number(n || 0);
  if (!v) return "—";
  if (v >= 1_000_000) return `$${(v / 1_000_000).toFixed(v >= 10_000_000 ? 1 : 2)}M`;
  if (v >= 1_000) return `$${(v / 1_000).toFixed(v >= 10_000 ? 0 : 1)}K`;
  return `$${v.toLocaleString()}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const fmtDateShort = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "2-digit" });
  } catch {
    return iso;
  }
};

export const stageTone = (stage) => {
  switch ((stage || "").toLowerCase()) {
    case "won": return "green";
    case "lost": return "red";
    case "proposal": return "amber";
    case "opportunity":
    case "meeting done": return "amber";
    case "pitched":
    case "researched": return "blue";
    default: return "neutral";
  }
};
